import Orthodontics from '../../routes/service/Orthodontics'

export default Orthodontics
